import axios from 'axios';
import Network from '@/services/network';

export default function handleBudgetTracker() {
    const network = new Network;

    const fetchTrackerBudgets = (query) => {
        return network.api('get', `/procurement/budget-tracker${query}`);
    }

    const fetchBudgetLines = (query) => {
        return network.api('get', `/procurement/budget-tracker/budget-lines${query}`);
    }

    const fetchApprovedBudgets = (budgetLineId, query) => {
        return network.api('get', `/procurement/budget-tracker/budget-lines/${budgetLineId}/approved-budgets${query}`);
    }

    const exportBudgetLineBva = (budgetLineId, data) => {
        return axios.post(`/procurement/budget-tracker/budget-lines/${budgetLineId}/bva-export`, data, {responseType: 'blob'});
    }

    const createTrackerBudget = (data, query) => {
        return network.api('post', `/procurement/budget-tracker${query}`, data);
    }

    const updateTrackerBudget = (id, data, query) => {
        return network.api('put', `/procurement/budget-tracker/${id + query}`, data);
    }

    const fetchTrackerBudget = (id, query) => {
        return network.api('get', `/procurement/budget-tracker/${id + query}`);
    }

    const fetchTrackerTree = (id, query) => {
        return network.api('get', `/procurement/budget-tracker/${id}/account/tree${query}`);
    }

    const fetchTrackerLine = (id, query) => {
        return network.api('get', `/procurement/budget-tracker/${id}/general${query}`);
    }

    const storeTrackerLine = (id, data, query) => {
        return network.api('post', `/procurement/budget-tracker/${id}/general${query}`, data);
    }

    const fetchTrackerPeriods = (id, query) => {
        return network.api('get', `/procurement/budget-tracker/${id}/periods${query}`);
    }

    const reviseTrackerBudget = (id, data, query) => {
        return network.api('post', `/procurement/budget-tracker/${id}/revise${query}`, data);
    }

    const updateVersionStatus = (id, versionId, data, query) => {
        return network.api('put', `/procurement/budget-tracker/${id}/versions/${versionId}/status${query}`, data);
    }

    const exportBudgetVersion = (id, versionId, query) => {
        return axios.get(`/procurement/budget-tracker/${id}/versions/${versionId}/export${query}`, {responseType: 'blob'});
    }

    const fetchBudgetApprovals = (query) => {
        return network.api('get', `/procurement/budget-tracker/approvals${query}`);
    }

    const fetchApprovalVersion = (id, versionId, query) => {
        return network.api('get', `/procurement/budget-tracker/approvals/${id}/versions/${versionId}${query}`);
    }

    const decideBudgetVersion = (id, versionId, data, query) => {
        return network.api('put', `/procurement/budget-tracker/approvals/${id}/versions/${versionId}${query}`, data);
    }

    return {
        fetchBudgetApprovals,
        fetchApprovalVersion,
        decideBudgetVersion,
        fetchTrackerBudgets,
        fetchBudgetLines,
        fetchApprovedBudgets,
        exportBudgetLineBva,
        createTrackerBudget,
        updateTrackerBudget,
        fetchTrackerBudget,
        fetchTrackerTree,
        fetchTrackerLine,
        storeTrackerLine,
        fetchTrackerPeriods,
        reviseTrackerBudget,
        updateVersionStatus,
        exportBudgetVersion,
    }
}
